import { Typography } from "@fullscript/aviary-web";
import { useTranslation } from "react-i18next";

import { l } from "@unauthenticated/signupSignin/locales/i18n";

import * as styles from "./ConnectNextStepsCard.styles";

interface Props {
  pracFirstName: string;
}

const ConnectNextStepsCard = ({ pracFirstName }: Props) => {
  const { t } = useTranslation();

  const nameOptions = {
    pracFirstName,
    interpolation: { escapeValue: false },
  };

  const steps = [
    t(l.connect.nextSteps.selectTimeslot, nameOptions),
    t(l.connect.nextSteps.requestGoesToOffice, nameOptions),
    t(l.connect.nextSteps.accountUnlocksStorefront, nameOptions),
  ];

  return (
    <div css={styles.card}>
      <Typography as="h2" variant="h3" intention="inverse" colorIntensity="bold" isMarginless>
        {t(l.connect.nextSteps.title)}
      </Typography>
      <div css={styles.steps}>
        {steps.map((step, index) => (
          <div key={step} css={styles.step}>
            <Typography
              variant="h3"
              intention="inverse"
              isItalic
              isMarginless
              customCss={styles.stepNumber}
            >
              {String(index + 1).padStart(2, "0")}
            </Typography>
            <Typography variant="callout" intention="inverse" colorIntensity="bold" isMarginless>
              {step}
            </Typography>
          </div>
        ))}
      </div>
    </div>
  );
};

export { ConnectNextStepsCard };
export type { Props as ConnectNextStepsCardProps };
